import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { __ } from 'react-i18n';
import { prop } from '../../../utilities';

interface Props {
  attribs: any[];
}

function SpecsList({ attribs }: Props) {
  return (
    <Wrapper>
      {attribs.map(attrib =>
        attrib.attrib_name && prop(attrib.values[0], 'attrib_value') ? (
          <AttribRow key={attrib.attrib_id}>
            <Attrib>{attrib.attrib_name}</Attrib>
            <Value>{prop(attrib.values[0], 'attrib_value')}</Value>
          </AttribRow>
        ) : null,
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  border: 0;
  border-radius: ${rem(2)};
  max-width: ${rem(480)};
  width: 100%;
  padding: 0;

  ${({ theme }) => theme.mediab.m760`
   max-width: initial;
  `}
`;

const Text = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};
`;

const AttribRow = styled(FlexRowCenterVertical)`
  padding: ${rem(12)} 0;
  border-bottom: ${({ theme }) => theme.borders.primary};

  &:last-child {
    border-bottom: 0;
  }

  ${({ theme }) => theme.mediab.m760`
    justify-content: space-between;

    &:last-child {
      padding-bottom: ${rem(8)};
    }
  `}
`;

const Attrib = styled(Text)`
  color: ${({ theme }) => theme.colors.placeholder};
  width: ${rem(206)};
  margin-right: ${rem(16)};
  word-break: break-word;
`;

const Value = styled(Text)`
  color: black;
  word-break: break-word;
  width: 100%;
`;

export { SpecsList };
